/**
 * Converts a string from snake_case to Title Case
 * @example snakeToTitleCase("face_to_face") // Returns "Face To Face"
 */
export const snakeToTitleCase = (str: string): string => {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Converts a PascalCase string to snake_case
 * @example toSnakeCase("PracticalTraining") // Returns "practical_training"
 */
export const toSnakeCase = (str: string): string => {
  return str.replace(/([A-Z])/g, (match, letter, offset) => {
    return offset === 0 ? letter.toLowerCase() : "_" + letter.toLowerCase();
  });
};
